var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00599C",
    d: "M256 0l222.5 128v256L256 512 33.5 384V128z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#004482",
    d: "M478.5 128L256 256v256l222.5-128z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#659AD2",
    d: "M33.5 128L256 256v256L33.5 384z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M256 382c-69.2 0-126-56.8-126-126s56.8-126 126-126c45 0 87 24 109.6 63.1l-54.8 31.6c-11-18.5-30.9-30-54.8-30-34 0-61.6 27.6-61.6 61.6s27.6 61.6 61.6 61.6c23.9 0 43.8-11.5 54.8-30l54.8 31.6C343 358 301 382 256 382z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406 212h-24v20h24v24h20v-24h24v-20h-24v-24h-20v24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406 280h-24v20h24v24h20v-24h24v-20h-24v-24h-20v24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpp);
export default __webpack_public_path__ + "static/media/cpp.9daf7958520c4f6b65a13c3da5bb2d47.svg";
export { ForwardRef as ReactComponent };